// The demo company on the client — the badge and the copy that go with it.
//
// The server is the control for all of it (the name lock, the email block, the billing exclusion
// and the reset guard all live in the API). Everything here is the human-facing half: making it
// obvious, at a glance, that what you are looking at is a sandbox.
//
// The badge is deliberately not styled like a normal label. A demo invoice that reads as real is
// the exact failure the whole feature exists to prevent, so DEMO is amber, uppercase and bordered
// (see `.demo-badge` in public/brand/aboo.css) rather than another quiet grey pill.
import { html } from './t4.js';

export const DEMO_LABEL = 'DEMO';

// Pure: is this /api/me company row the demo one? The API sends `is_demo` on every company
// (src/routes/tenant.py); anything else — including an older API that does not send the field —
// reads as "not a demo", which is the safe direction to be wrong in.
export const isDemoCompany = company => !!(company && company.is_demo);

// The badge itself. `title` explains it on hover for anyone who has not met it before.
export function demoBadge(){
  return html`<span class="demo-badge" title="This is a practice company. Its data is not real, it cannot send email, and it is never billed.">${DEMO_LABEL}</span>`;
}

// The badge for the app chrome — only rendered when a company is actually in scope AND is a demo.
// Returns null otherwise, so a caller can drop it straight into a template.
export const demoChrome = company => (isDemoCompany(company) ? demoBadge() : null);

export const DEMO_ROW_NOTE =
  'Practice company — reset it whenever you want a clean slate. Never billed, and it cannot send email.';
